import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

import Header from '../../components/header';
import TitlePage from '../../components/title-page';
import LandingPageT1 from '../../components/themes/theme-1/body-lp';

export default class project extends Component {
	// Esta pagina es el resumen del proyecto: banner con los accesos a Follow Up,
	// preview de landing page y edicion, mas la informacion del juego y de la
	// compania. El envio de correo vive en Follow Up (Message Center).
	state = {
		company_id: 0,
		project_id: 0,
		updated_at: "",
		company_name: "",
		company_description: "",
		logo_src: "",
		project_title: "",
		project_type: "",
		banner_title: "",
		banner_description: "",
		banner_src: "",
		links: []
	}

	async componentDidMount() {
		//if page reloads without close any modal
		document.querySelector('body').classList.remove("no-scroll");

		const company_id = this.props.match.params.company_id;
		const project_id = this.props.match.params.project_id;

		await this.setState({ company_id, project_id });

		// Solo los datos del proyecto. Antes se traian ademas todos los publishers,
		// una peticion de empleados por cada uno, las categorias de prensa con sus
		// contactos y las submission lists con los suyos: mas de 270 peticiones por
		// carga para alimentar una interfaz que esta pagina no dibuja.
		await this.loadApiProject(company_id, project_id);
	}

	loadApiProject = async (company_id, project_id) => {
		try {
			const response = await api.get(`companies/${company_id}/projects/${project_id}`);
			const response2 = await api.get(`companies/${company_id}/projects/${project_id}/banner`);
			const response3 = await api.get(`companies/${company_id}/projects/${project_id}/files`);

			await this.setState({
				project_type: response.data.project_type,
				// updated_at no se asignaba en ningun sitio, asi que "Last sent" salia
				// siempre vacio aunque el campo ya venia en esta misma respuesta.
				updated_at: response.data.updated_at || "",
				project_title: response.data.title, 
				company_name: response.data.company_name,
				company_description: response.data.company_description,
				banner_title: response2.data.title,
				banner_description: response2.data.description,
				links: response3.data,
			});

			if(response.data.logo_url) {
				this.setState({
					logo_src: 'https://seat7-uploads.s3.amazonaws.com/'+response.data.logo_url,
				})
			}

			if(response2.data.image_url) {
				this.setState({
					banner_src: 'https://seat7-uploads.s3.amazonaws.com/'+response2.data.image_url,
				})
			}
		} catch (error) {
			console.log(error);
		}
	}

	render() {
		let banner;
		if(this.state.banner_src) {
			banner = <img src={this.state.banner_src} alt={this.state.banner_title}/>
		} else {
			banner = <span className="without-banner">Without banner</span>
		}

		return (
			<div data-page="project">
				<Header />

				<TitlePage title="Project Manager"/>

				<div className="container-fluid" data-component="project-content">
					<div className="container">
						<div className="row">
							<br />
							<a href="/" className="btn blue">Back</a>
							<br />
							<br />
						</div>
						<div className="project-header row">
							<h1 className="title">{this.state.company_name}: {this.state.project_title}</h1>
							<span className="data">Last sent: {(this.state.updated_at || "").substring(0, 10)}</span>
						</div>

						 <div className={`project-banner row ${!this.state.banner_src ? "no-banner" : ""}`}>
							<div className="banner-image">
								{banner}

								<div className="banner-actions">
									{/* 
									<Link to={`/email-scheduler/${this.state.company_id}/${this.state.project_id}`} className="btn-preview" title="Schedule Email">
										<span className="material-icons-outlined"><img src="https://seat7-uploads.s3.us-east-1.amazonaws.com/icons/schedule.png" alt="Schedule email" /></span>
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999"><path d="M508.745 246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818 239.784 3.249 246.035a16.896 16.896 0 000 19.923c4.569 6.257 113.557 153.206 252.748 153.206s248.174-146.95 252.748-153.201a16.875 16.875 0 000-19.922zM255.997 385.406c-102.529 0-191.33-97.533-217.617-129.418 26.253-31.913 114.868-129.395 217.617-129.395 102.524 0 191.319 97.516 217.617 129.418-26.253 31.912-114.868 129.395-217.617 129.395z"/><path d="M255.997 154.725c-55.842 0-101.275 45.433-101.275 101.275s45.433 101.275 101.275 101.275S357.272 311.842 357.272 256s-45.433-101.275-101.275-101.275zm0 168.791c-37.23 0-67.516-30.287-67.516-67.516s30.287-67.516 67.516-67.516 67.516 30.287 67.516 67.516-30.286 67.516-67.516 67.516z"/></svg>
									</Link>
									*/}
									<Link to={`/follow-up/${this.state.company_id}/${this.state.project_id}`} className="btn-preview" title="Follow Up Project">
										<span className="material-icons-outlined"><img src="https://seat7-uploads.s3.us-east-1.amazonaws.com/icons/chat.png" alt="Follow up" /></span>
											{/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999"><path d="M508.745 246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818 239.784 3.249 246.035a16.896 16.896 0 000 19.923c4.569 6.257 113.557 153.206 252.748 153.206s248.174-146.95 252.748-153.201a16.875 16.875 0 000-19.922zM255.997 385.406c-102.529 0-191.33-97.533-217.617-129.418 26.253-31.913 114.868-129.395 217.617-129.395 102.524 0 191.319 97.516 217.617 129.418-26.253 31.912-114.868 129.395-217.617 129.395z"/><path d="M255.997 154.725c-55.842 0-101.275 45.433-101.275 101.275s45.433 101.275 101.275 101.275S357.272 311.842 357.272 256s-45.433-101.275-101.275-101.275zm0 168.791c-37.23 0-67.516-30.287-67.516-67.516s30.287-67.516 67.516-67.516 67.516 30.287 67.516 67.516-30.286 67.516-67.516 67.516z"/></svg>*/}
									</Link>

									<Link to={`/landing-page-preview/${this.state.company_id}/${this.state.project_id}`} className="btn-preview" title="Preview Project">
										<span className="material-icons-outlined"><img src="https://seat7-uploads.s3.us-east-1.amazonaws.com/icons/preview.png" alt="Preview landing page" /></span>
										{/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.999 511.999"><path d="M508.745 246.041c-4.574-6.257-113.557-153.206-252.748-153.206S7.818 239.784 3.249 246.035a16.896 16.896 0 000 19.923c4.569 6.257 113.557 153.206 252.748 153.206s248.174-146.95 252.748-153.201a16.875 16.875 0 000-19.922zM255.997 385.406c-102.529 0-191.33-97.533-217.617-129.418 26.253-31.913 114.868-129.395 217.617-129.395 102.524 0 191.319 97.516 217.617 129.418-26.253 31.912-114.868 129.395-217.617 129.395z"/><path d="M255.997 154.725c-55.842 0-101.275 45.433-101.275 101.275s45.433 101.275 101.275 101.275S357.272 311.842 357.272 256s-45.433-101.275-101.275-101.275zm0 168.791c-37.23 0-67.516-30.287-67.516-67.516s30.287-67.516 67.516-67.516 67.516 30.287 67.516 67.516-30.286 67.516-67.516 67.516z"/></svg> */}
									</Link>

									<Link to={`/edit-project/${this.state.company_id}/${this.state.project_id}`} className="btn-edit" title="Edit Project">
										<span className="material-icons-outlined"><img src="https://seat7-uploads.s3.us-east-1.amazonaws.com/icons/edit.png" alt="Edit project" /></span>
										{/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M352.459 220c0-11.046-8.954-20-20-20h-206c-11.046 0-20 8.954-20 20s8.954 20 20 20h206c11.046 0 20-8.954 20-20zM126.459 280c-11.046 0-20 8.954-20 20s8.954 20 20 20H251.57c11.046 0 20-8.954 20-20s-8.954-20-20-20H126.459z"/><path d="M173.459 472H106.57c-22.056 0-40-17.944-40-40V80c0-22.056 17.944-40 40-40h245.889c22.056 0 40 17.944 40 40v123c0 11.046 8.954 20 20 20s20-8.954 20-20V80c0-44.112-35.888-80-80-80H106.57c-44.112 0-80 35.888-80 80v352c0 44.112 35.888 80 80 80h66.889c11.046 0 20-8.954 20-20s-8.954-20-20-20z"/><path d="M467.884 289.572c-23.394-23.394-61.458-23.395-84.837-.016l-109.803 109.56a20.005 20.005 0 00-5.01 8.345l-23.913 78.725a20 20 0 0024.476 25.087l80.725-22.361a19.993 19.993 0 008.79-5.119l109.573-109.367c23.394-23.394 23.394-61.458-.001-84.854zM333.776 451.768l-40.612 11.25 11.885-39.129 74.089-73.925 28.29 28.29-73.652 73.514zM439.615 346.13l-3.875 3.867-28.285-28.285 3.862-3.854c7.798-7.798 20.486-7.798 28.284 0 7.798 7.798 7.798 20.486.014 28.272zM332.459 120h-206c-11.046 0-20 8.954-20 20s8.954 20 20 20h206c11.046 0 20-8.954 20-20s-8.954-20-20-20z"/></svg> */}
									</Link>
								</div>
							</div>
						</div>
						<div className="row">
							<br />
						<h2 className="title" style={{ color: '#1141B0' }}>{'About ' + this.state.project_title}</h2>
						</div>
									{/* La lista de archivos se ve en el preview de landing page, que tiene su propio
									    boton arriba, asi que aqui va vacia a proposito. Pero como array: el componente
									    hace links.length y la cadena "" solo funcionaba de casualidad. */}
									<LandingPageT1
										isPreview={false}
										bannerText={this.state.banner_description}
										companyName={this.state.company_name}
										aboutCompany={this.state.company_description}
										links={[]}
									/>						
					</div>
				</div>


			</div>
		)
	};
}